var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 22.3333H22.3333V21.8333V3.16667V2.66667H21.8333H3.16667H2.66667V3.16667V21.8333V22.3333H3.16667H21.8333ZM3.16667 1H21.8333C23.0239 1 24 1.97614 24 3.16667V21.8333C24 23.0239 23.0239 24 21.8333 24H3.16667C1.97614 24 1 23.0239 1 21.8333V3.16667C1 1.97614 1.97614 1 3.16667 1ZM6.33333 10.3333H8V18.6667H6.33333V10.3333ZM11.6667 6.33333H13.3333V18.6667H11.6667V6.33333ZM17 14.3333H18.6667V18.6667H17V14.3333Z",
    fill: "#545454",
    stroke: "#263668"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.cfbf7528fa7067050ad4a01d23642d3b.svg";
export { ForwardRef as ReactComponent };